var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{staticStyle:{"height":"auto"},attrs:{"type":_vm.getTagType}},[_vm._v("\n  "+_vm._s(_vm.$t('common_words.code'))+": "+_vm._s(_vm.worker.code || '-')+" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.$t('common_words.name'))+": "+_vm._s(_vm.worker.name || '-')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }